import LogRocket from "logrocket";
import createPlugin from "logrocket-vuex";

// Send All Vuex mutations to LogRocket with exceptions
const logrocketPlugin = createPlugin(LogRocket, function(mutation) {
  // Sanitize specific mutations
  // return null Removes the mutation from LogRocket
  // return {...mutaion, removeThisKey: undefined} returns parts of mutation

  if (mutation.type === "auth/SET_TOKEN") {
    return null;
  }
  if (mutation.type === "auth/SET_TOKEN_EXPIRATION") {
    return null;
  }

  return mutation;
});

export default logrocketPlugin;
